import {useRouter} from 'next/router';
import {pathOr} from 'ramda';
import {useCallback, useContext, useMemo} from 'react';

import useUserActions from '@/src/app/store/user/useUserActions';
import PopupContext from '@/src/popup/utils/PopupContext';
import AddressWidgetLayout from '@/src/profile/accountSettings/components/AddressWidgetLayout';
import ChangeAddressPopup from '@/src/profile/accountSettings/containers/ChangeAddressPopup';

const AddressWidget = () => {
  const {user} = useUserActions();
  const {locale} = useRouter();
  const {openPopup} = useContext(PopupContext);
  const locationFieldName = useMemo(() => {
    return `name_${locale}`;
  }, [locale]);

  const handleEditClick = useCallback(() => {
    // @ts-ignore
    openPopup({
      popup: <ChangeAddressPopup />,
      options: {withCloseButton: true},
    });
  }, []);

  return (
    <AddressWidgetLayout
      onEditClick={handleEditClick}
      cityName={pathOr('', ['profile', 'city', locationFieldName], user)}
      stateName={pathOr('', ['profile', 'state', locationFieldName], user)}
      countryName={pathOr('', ['profile', 'country', locationFieldName], user)}
    />
  );
};

export default AddressWidget;
